import type { ReactNode } from 'react';
import { Counter } from '../Counter';
import { Typography } from '../Typography';

export interface BannerCounterProps {
  /** Message displayed in the banner. */
  children: ReactNode;
  /** Progress or count displayed in the trailing pill. */
  count: ReactNode;
  /** Optional test hook for consumers that need to identify the banner. */
  testId?: string;
}

/**
 * A full-width banner with a trailing progress counter.
 * @see {@link https://www.figma.com/design/jkuMhkzDQH2lAUYa8CQvto/Primer-DS?node-id=9021-1057&m=dev|Figma Design}
 */
export function BannerCounter({ children, count, testId }: BannerCounterProps) {
  return (
    <div data-testid={testId} className="flex items-center gap-2 bg-interactive-quiet px-5 py-3">
      <Typography variant="body" size="medium" color="info" as="span">
        {children}
      </Typography>
      <span className="ml-auto">
        <Counter count={count} />
      </span>
    </div>
  );
}

export default BannerCounter;
